import * as z from 'zod'
import emailSchema from './emailSchema'

const notEmptyString = () => z.string().nonempty()

export const schema = emailSchema.extend({
  company: notEmptyString(),
  department: notEmptyString(),
  firstName: notEmptyString(),
  lastName: notEmptyString(),
  phone: notEmptyString(),
  expectStartDate: z.optional(z.string()),
  expectNumberOfBands: z.optional(z.string()),
  inquiryDetails: z.optional(z.string()),
  termCheck: z.boolean().refine((v) => v === true)
})

export default schema
